import { Link } from "react-router-dom";

export default function Quote() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden bg-primary-950">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-white"></div>
        <div className="absolute -bottom-20 -left-10 w-80 h-80 rounded-full bg-white"></div>
      </div>
      <div className="relative z-10 mx-auto max-w-4xl px-4 md:px-6 text-center">
        <p className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium text-white/90 tracking-wide">
          <i className="ri-double-quotes-l"></i>
          PHILOSOPHY
        </p>
        <h2 className="mt-6 font-heading text-3xl md:text-5xl font-bold text-white leading-tight tracking-tight">
          <span className="md:hidden">
            “재판의 흐름을
            <br />
            아는 변호사”
          </span>
          <span className="hidden md:inline">“재판의 흐름을 아는 변호사”</span>
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-sm md:text-lg leading-relaxed text-white/85">
          판사·검사로 쌓은 풍부한 경륜, 이제는 의뢰인을 위한 강력한 변호로 이어갑니다.
          <br />
        </p>
        <div className="mt-8 flex justify-center">
          <Link
            to="/criminal"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-sky-400 px-7 py-3.5 text-sm font-semibold text-primary-950 hover:bg-sky-300 transition-colors"
          >
            형사사건 전문 분야 보기
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}